<!--
  Program: Bread crumb
  Author: SDL
  Brief: Components that visually show where the current user is
-->
<template>
  <div class="ui--content-heading">
    <strong class="navbar-brand">{{$t(gcrmTitle) === gcrmTitle ? title : $t(gcrmTitle)}} </strong>

    <nav aria-label="breadcrumb">
      <ol class="breadcrumb float-right">
        <li class="breadcrumb-item" v-if="home">
          <router-link :to="{ name: 'mainIndexPage' }">{{ homeText }}</router-link>
        </li>
        <li
          class="breadcrumb-item"
          :class="{ active: index === list.length - 1 }"
          v-for="(item, index) in list"
          :key="item.menuId"
        >
          <a>{{ getLabel(item) }}</a>
          <!-- <a :href="'' !== item.menuUrl && item.menuUrl ? item.menuUrl : 'javascript:'">{{item.localeLabel}}</a> -->
          <!-- <router-link v-if="index === list.length - 1" :to="item.menuUrl" tag="span">{{item.localeLabel}}</router-link>
          <a :href="'' !== item.menuUrl && item.menuUrl ? item.menuUrl : 'javascript:'" v-else>{{item.localeLabel}}</a> -->
        </li>

        <!-- <li class="breadcrumb-item"><a href="#">Menu1</a></li>
        <li class="breadcrumb-item"><a href="#">Submenu1</a></li>
        <li class="breadcrumb-item active" aria-current="page">Submenu1-1</li> -->
      </ol>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import SDLLocale from '@/mixin/SDLLocale';

export default {
  name: 'Breadcrumb',
  mixins: [SDLLocale],
  props: {
    home: {
      required: false,
      type: Boolean,
      default: false,
    },
    homeText: {
      required: false,
      type: String,
      default: 'Home',
    },
    gcrmTitle: {
      required: false,
      type: String,
      default: '',
    },
  },
  data() {
    return {
      title: '',
      list: [],
    };
  },
  computed: {
    ...mapGetters({
      menus: 'getMenus',
    }),
    menu() {
      return _.find(this.menus, ['menuId', this.menuId]);
    },
    menuId() {
      return this.$route.meta.menuId;
    },
    pageId() {
      return this.$route.meta.pageId;
    },
  },
  watch: {
    menus() {
      this.setTitle();
      this.setBreadcrumb();
    },
    locale() {
      this.setTitle();
    },
    $route() {
      this.setTitle();
      this.setBreadcrumb();
    },
  },
  methods: {
    getParentMenu(parentId) {
      return this.menus.find(item => item.menuId === parentId);
    },
    setTitle() {
      if (this.menu) {
        this.title = this.getLabel(this.menu);
        // this.title = this.menu.localeLabel;
      }
    },
    setBreadcrumb() {
      if (this.menu) {
        this.list = [this.menu];
        for (let i = this.menu.menuLevel - 1; i > 0; i -= 1) {
          const parentMenu = this.getParentMenu(this.list[0].parentId);
          if (parentMenu) {
            this.list = [parentMenu, ...this.list];
          }
        }
      }
    },
  },
  created() {
    this.setTitle();
    this.setBreadcrumb();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/control/breadcrumb/Breadcrumb.vue